import { render, staticRenderFns } from "./ProductInfoGroup.vue?vue&type=template&id=408d238a&"
import script from "./ProductInfoGroup.vue?vue&type=script&lang=js&"
export * from "./ProductInfoGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports